// These states indicate the loading states of requests: initial, loading, loaded and error

export const stateInitial: State = {
  loading: false,
  loaded: false,
  error: false,
  errorMessage: "",
};

export const stateLoading: State = {
  loading: true,
  loaded: false,
  error: false,
  errorMessage: "",
};

export const stateLoaded: State = {
  loading: false,
  loaded: true,
  error: false,
  errorMessage: "",
};

export const stateError: State = {
  loading: false,
  loaded: false,
  error: true,
  errorMessage: "",
};

export interface State {
  loading: boolean;
  loaded: boolean;
  error: boolean;
  errorMessage: string;
}

export interface LoadState<T> extends State {
  result?: T;
}

// TODO: query should be typed here <T, Q>
export interface PaginatedLoadState<T> extends LoadState<T> {
  query?: object;
  page?: number;
  pagesTotal?: number;
  total?: number;
}

export type Pagination = {
  total: number;
  pagesTotal: number;
};

export type Paginated<T> = Pagination & {
  page: number;
  pageSize: number;
  result: T;
};
